import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full bg-white rounded-xl p-4 pb-5 lg:p-6 lg:pb-8 flex flex-col justify-start items-center relative shadow-modal overflow-hidden"
}
const _hoisted_2 = { class: "w-full flex flex flex-col mdlg:items-center mdlg:flex-row justify-between" }
const _hoisted_3 = { class: "t-18m md:t-22m text-wrh-blue-dark" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Timeline ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" View Timeline ")
const _hoisted_7 = { class: "w-full flex items-center justify-center space-x-4 lg:space-x-20 mt-6 md:mt-10" }
const _hoisted_8 = { class: "grid grid-cols-5 grid-rows-1 pl-0 -mx-6 md:mx-0" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex items-center justify-center relative" }
const _hoisted_11 = { class: "flex flex-col items-center justify-center mdlg:relative absolute top-4 mdlg:top-0 mdlg:right-0 right-2" }
const _hoisted_12 = { class: "t-22m md:28m mdlg:text-6xl lg:t-90b text-wrh-blue-dark" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "md:t-16m lg:t-18m text-wrh-blue-dark capitalize hidden mdlg:inline whitespace-nowrap" }, "Total Completed", -1)
const _hoisted_14 = { class: "text-center mt-6 mdlg:hidden" }

import {
  ref, computed, onMounted, PropType, toRefs,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { IMilestone, ITimeline, ReqHomesDocument } from '@/models';
import { getTimeline } from '@/api';
import {
  Milestones, MyTimeLineStatus, Routes, StoreActions,
} from '@/constants';
import { checkStringEquality, updateMilestoneStatus } from '@/util/funcs';
import ContractIcon from './icons/ContractIcon.vue';
import DollarIcon from './icons/DollarIcon.vue';
import SelectionsIcon from './icons/SelectionsIcon.vue';
import HammerIcon from './icons/HammerIcon.vue';
import HomeIcon from './icons/HomeIcon.vue';
import HomeProgressSkeleton from '@/components/skeleton/HomeProgressSkeleton.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  isTimelinePanel: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
},
  emits: ['selectedMilestoneEmit'],
  setup(__props, { emit }) {

const props = __props
const router = useRouter();

const store = useStore();
const isTimelinePage = ref(false);
const data = ref({} as ITimeline);
const milestones = ref<IMilestone[]>([]);
const selectedMilestone = ref({} as IMilestone);
const percentage = ref<number>();

isTimelinePage.value = router.currentRoute.value.name === Routes.TIMELINE;

const selectedHome = computed(() => store.getters.selectedHome as ReqHomesDocument);


const { isTimelinePanel } = toRefs(props);
const setCurrentTimelineDetails = () => {
  milestones.value.forEach((milestone, idx) => {
    if (milestone.status === MyTimeLineStatus.CURRENT) {
      selectedMilestone.value = milestone;
    }
  });
  if (!selectedMilestone.value.name) {
    selectedMilestone.value = milestones.value[milestones.value.length - 1];
  }
  emit('selectedMilestoneEmit', selectedMilestone.value);
};

const getData = async () => {
  data.value = store.getters.getTimeline as ITimeline;
  if (!data.value.milestones) {
    store.dispatch(StoreActions.SET_APPOINTMENTS_SKELETON, true);
    const response = await getTimeline(selectedHome.value.id);
    const timelineData = updateMilestoneStatus(response.timeline);
    await store.dispatch(StoreActions.SET_TIMELINE, timelineData);
    await store.dispatch(StoreActions.SET_APPOINTMENTS, response.appointments);
    store.dispatch(StoreActions.SET_APPOINTMENTS_SKELETON, false);
  }
  data.value = store.getters.getTimeline as ITimeline;
  milestones.value = data.value.milestones;
  percentage.value = data.value.percentage;
  setCurrentTimelineDetails();
};

const handleOnClick = (milestone:IMilestone) => {
  if (isTimelinePage.value && selectedMilestone.value !== milestone) {
    selectedMilestone.value = milestone;
    emit('selectedMilestoneEmit', selectedMilestone.value);
  }
};

const setSpanClass = (milestoneName:string, currentStatus?: string) => {
  let requiredClass = '';
  if (checkStringEquality(milestoneName, Milestones.CONTRACT)) {
    requiredClass = 'hidden ';
    return requiredClass;
  }
  if (currentStatus && (checkStringEquality(currentStatus, MyTimeLineStatus.DONE) || checkStringEquality(currentStatus, MyTimeLineStatus.CURRENT))) {
    requiredClass += 'bg-wrh-blue-light';
  }
  if (currentStatus && checkStringEquality(currentStatus, MyTimeLineStatus.PENDING)) {
    requiredClass += 'bg-wrh-gray-light';
  }
  return requiredClass;
};

const setClass = (currentStatus?: string, type = 'text'): string => {
  let className = '';
  if (currentStatus && checkStringEquality(currentStatus, MyTimeLineStatus.DONE)) {
    className = type === 'bg' ? 'bg-wrh-blue-light' : 'text-wrh-blue-light';
  } else if (currentStatus && checkStringEquality(currentStatus, MyTimeLineStatus.CURRENT)) {
    className = type === 'bg' ? 'bg-wrh-green-medium' : 'text-wrh-green-medium';
  } else if (currentStatus && checkStringEquality(currentStatus, MyTimeLineStatus.PENDING)) {
    className = type === 'bg' ? 'bg-wrh-gray-light' : 'text-wrh-gray-light';
  }
  return className;
};

onMounted(async () => {
  await getData();
});

const iconSelector = (mileStoneName: string) => {
  let icon;
  if (Milestones.CONTRACT === mileStoneName) {
    icon = ContractIcon;
  } else if (Milestones.FINANCE === mileStoneName) {
    icon = DollarIcon;
  } else if (Milestones.SELECTIONS === mileStoneName) {
    icon = SelectionsIcon;
  } else if (Milestones.CONSTRUCTION === mileStoneName) {
    icon = HammerIcon;
  } else if (Milestones.OWNERSHIP === mileStoneName) {
    icon = HomeIcon;
  } else {
    icon = '';
  }
  return icon;
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (milestones.value.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, [
            _hoisted_4,
            (_unref(isTimelinePanel))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(Click each for details)"))
              : _createCommentVNode("", true)
          ]),
          (!isTimelinePage.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "t-12r mdlg:t-14r text-wrh-blue-light capitalize",
                to: {name: _unref(Routes).TIMELINE }
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(milestones.value, (milestone, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "flex flex-col items-center space-y-4 w-[calc(5rem-12px)] moblands:w-[calc(7rem-12px)] md:w-[calc(7rem-12px)] lg:w-[calc(12rem-12px)]",
                onClick: ($event: any) => (handleOnClick(milestone)),
                key: index
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(iconSelector(milestone.name.toLowerCase())), {
                  id: milestone.name.toLowerCase(),
                  class: _normalizeClass([setClass(milestone.status), 'w-5 h-5 cursor-pointer mdlg:w-10 mdlg:h-10', {'transform scale-125 ': _unref(checkStringEquality)(selectedMilestone.value.name, milestone.name.toLowerCase())}])
                }, null, 8, ["id", "class"])),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['flex-grow h-[2px] w-[calc(5rem-12px)] moblands:w-[calc(7rem-12px)] md:w-[calc(7rem-12px)] lg:w-[calc(12rem-12px)] absolute right-0', setSpanClass(milestone.name, milestone.status), milestone.status]),
                    "aria-hidden": "true"
                  }, null, 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(['rounded-full w-2 h-2 md:w-3 relative z-2 md:h-3 cursor-pointer', setClass(milestone.status, 'bg'), {'transform scale-125':_unref(checkStringEquality)(milestone.name, selectedMilestone.value.name)}])
                  }, null, 2)
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass([
            {'transform scale-125 font-bold':_unref(checkStringEquality)(milestone.name,selectedMilestone.value.name)},
            't-16r hidden mdlg:inline cursor-pointer',
            setClass(milestone.status),])
                }, _toDisplayString(milestone.name), 3)
              ], 8, _hoisted_9))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(percentage.value) + "%", 1),
            _hoisted_13
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", {
            class: _normalizeClass(['t-16m', setClass(selectedMilestone.value.status)])
          }, _toDisplayString(selectedMilestone.value.name), 3)
        ])
      ]))
    : (_openBlock(), _createBlock(HomeProgressSkeleton, { key: 1 }))
}
}

})